import React from "react";

interface StarRatingProp {
  rating: number;
}
const ShowStarRating: React.FC<StarRatingProp> = ({ rating }) => {
  return (
    <div className="flex">
      {[...Array(5)].map((_, index) => (
        <svg
          key={index}
          className={`w-5 h-5 ${
            index < rating ? "text-yellow-400" : "text-gray-300"
          }`}
          fill="currentColor"
          viewBox="0 0 25 25"
        >
          <path
            d="M12.666 2.5L15.756 8.76L22.666 9.77L17.666 14.64L18.846 21.52L12.666 18.27L6.48602 21.52L7.66602 14.64L2.66602 9.77L9.57602 8.76L12.666 2.5Z"
            stroke={index < rating ? "#EB8D00" : "#D1D5DB"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ))}
    </div>
  );
};

export default ShowStarRating;
